import { MasterdataEntityDefinition } from './types/masterdata-entity-definition';
import { MASTERDATA_CUSTOMER } from './definitions/customer';
import { MASTERDATA_PRODUCT } from './definitions/product';
import { MASTERDATA_COLLECTOR } from './definitions/collector';
import { MASTERDATA_COMMISSION_RECIPIENT } from './definitions/commission-recipient';
import { MASTERDATA_CONDITION_SHEET } from './definitions/condition-sheet';
import { MASTERDATA_CONSTRUCTION_SITE } from './definitions/construction-site';
import { MASTERDATA_COST_CENTER } from './definitions/cost-center';
import { MASTERDATA_COUNTRY } from './definitions/country';
import { MASTERDATA_CURRENCY } from './definitions/currency';
import { MASTERDATA_CURRENT_ACCOUNT } from './definitions/current-account';
import { MASTERDATA_DISTRIBUTION_CHANNEL } from './definitions/distribution-channel';
import { MASTERDATA_DIVISION } from './definitions/division';
import { MASTERDATA_DOCUMENT_PRESETS_TYPE } from './definitions/document-presets-type';
import { MASTERDATA_EMPLOYEE } from './definitions/employee';
import { MASTERDATA_FIXED_ASSET } from './definitions/fixed-asset';
import { MASTERDATA_GENERAL_LEDGER } from './definitions/general-ledger';
import { MASTERDATA_MANUAL_ARTICLE } from './definitions/manual-article';
import { MASTERDATA_PAYMENT_METHOD } from './definitions/payment-method';
import { MASTERDATA_REPRESENTATIVE } from './definitions/representative';
import { MASTERDATA_SALES_ORGANISATION } from './definitions/sales-organisation';
import { MASTERDATA_SITE_ENGINEER } from './definitions/site-engineer';
import { MASTERDATA_STORAGE_SITE } from './definitions/storage-site';
import { MASTERDATA_TASK_TYPE } from './definitions/task-type';
import { MASTERDATA_TAX_RATE } from './definitions/tax-rate';
import { MASTERDATA_CHECKLIST } from './definitions/checklist';
import { MASTERDATA_CONDITION } from './definitions/condition';
import { MASTERDATA_DEPARTMENT } from './definitions/department';
import { MASTERDATA_DISTRIBUTION_TYPE } from './definitions/distribution-type';
import { MASTERDATA_DOCUMENT_NOTE_CATEGORY } from './definitions/document-note-category';
import { MASTERDATA_MEMBER } from './definitions/member';
import { MASTERDATA_POSTING_SYMBOL } from './definitions/posting-symbol';
import { MASTERDATA_PRODUCT_DEVELOPMENT } from './definitions/product-development';
import { MASTERDATA_PRODUCT_GROUP } from './definitions/product-group';
import { MASTERDATA_PRODUCTION_SITE } from './definitions/production-site';
import { MASTERDATA_PROJECT } from './definitions/project';
import { MASTERDATA_PROMOTION } from './definitions/promotion';
import { MASTERDATA_PURCHASE_ORGANIZATION } from './definitions/purchase-organization';
import { MASTERDATA_SELLING_TYPE } from './definitions/selling-type';
import { MASTERDATA_STOCK } from './definitions/stock';
import { MASTERDATA_STOCK_SYMBOL } from './definitions/stock-symbol';
import { MASTERDATA_SUPPLIER } from './definitions/supplier';
import { MASTERDATA_TERMS_OF_PAYMENT } from './definitions/terms-of-payment';
import { MASTERDATA_TIME_MOVEMENT_TYPE } from './definitions/time-movement-type';
import { MASTERDATA_UNIT } from './definitions/unit';
import { MASTERDATA_USER } from './definitions/user';
import { MASTERDATA_CONTACT } from './definitions/contact';

export { MASTERDATA_CUSTOMER } from './definitions/customer';
export { MASTERDATA_PRODUCT } from './definitions/product';
export { MASTERDATA_COLLECTOR } from './definitions/collector';
export { MASTERDATA_COMMISSION_RECIPIENT } from './definitions/commission-recipient';
export { MASTERDATA_CONDITION_SHEET } from './definitions/condition-sheet';
export { MASTERDATA_CONSTRUCTION_SITE } from './definitions/construction-site';
export { MASTERDATA_COST_CENTER } from './definitions/cost-center';
export { MASTERDATA_COUNTRY } from './definitions/country';
export { MASTERDATA_CURRENCY } from './definitions/currency';
export { MASTERDATA_CURRENT_ACCOUNT } from './definitions/current-account';
export { MASTERDATA_DISTRIBUTION_CHANNEL } from './definitions/distribution-channel';
export { MASTERDATA_DIVISION } from './definitions/division';
export { MASTERDATA_DOCUMENT_PRESETS_TYPE } from './definitions/document-presets-type';
export { MASTERDATA_EMPLOYEE } from './definitions/employee';
export { MASTERDATA_FIXED_ASSET } from './definitions/fixed-asset';
export { MASTERDATA_GENERAL_LEDGER } from './definitions/general-ledger';
export { MASTERDATA_MANUAL_ARTICLE } from './definitions/manual-article';
export { MASTERDATA_PAYMENT_METHOD } from './definitions/payment-method';
export { MASTERDATA_REPRESENTATIVE } from './definitions/representative';
export { MASTERDATA_SALES_ORGANISATION } from './definitions/sales-organisation';
export { MASTERDATA_SITE_ENGINEER } from './definitions/site-engineer';
export { MASTERDATA_STORAGE_SITE } from './definitions/storage-site';
export { MASTERDATA_TASK_TYPE } from './definitions/task-type';
export { MASTERDATA_TAX_RATE } from './definitions/tax-rate';
export { MASTERDATA_CHECKLIST } from './definitions/checklist';
export { MASTERDATA_CONDITION } from './definitions/condition';
export { MASTERDATA_DEPARTMENT } from './definitions/department';
export { MASTERDATA_DISTRIBUTION_TYPE } from './definitions/distribution-type';
export { MASTERDATA_DOCUMENT_NOTE_CATEGORY } from './definitions/document-note-category';
export { MASTERDATA_MEMBER } from './definitions/member';
export { MASTERDATA_POSTING_SYMBOL } from './definitions/posting-symbol';
export { MASTERDATA_PRODUCT_DEVELOPMENT } from './definitions/product-development';
export { MASTERDATA_PRODUCT_GROUP } from './definitions/product-group';
export { MASTERDATA_PRODUCTION_SITE } from './definitions/production-site';
export { MASTERDATA_PROJECT } from './definitions/project';
export { MASTERDATA_PROMOTION } from './definitions/promotion';
export { MASTERDATA_PURCHASE_ORGANIZATION } from './definitions/purchase-organization';
export { MASTERDATA_SELLING_TYPE } from './definitions/selling-type';
export { MASTERDATA_STOCK } from './definitions/stock';
export { MASTERDATA_STOCK_SYMBOL } from './definitions/stock-symbol';
export { MASTERDATA_SUPPLIER } from './definitions/supplier';
export { MASTERDATA_TERMS_OF_PAYMENT } from './definitions/terms-of-payment';
export { MASTERDATA_TIME_MOVEMENT_TYPE } from './definitions/time-movement-type';
export { MASTERDATA_UNIT } from './definitions/unit';
export { MASTERDATA_USER } from './definitions/user';

/** A function, not a module-scope array: the registry seeds it at injection time,
    after every definition module has initialised. */
export function masterdataEntityDefinitions(): MasterdataEntityDefinition<any>[] {
  return [
    MASTERDATA_CUSTOMER,
    MASTERDATA_PRODUCT,
    MASTERDATA_COLLECTOR,
    MASTERDATA_COMMISSION_RECIPIENT,
    MASTERDATA_CONDITION_SHEET,
    MASTERDATA_CONSTRUCTION_SITE,
    MASTERDATA_COST_CENTER,
    MASTERDATA_COUNTRY,
    MASTERDATA_CURRENCY,
    MASTERDATA_CURRENT_ACCOUNT,
    MASTERDATA_DISTRIBUTION_CHANNEL,
    MASTERDATA_DIVISION,
    MASTERDATA_DOCUMENT_PRESETS_TYPE,
    MASTERDATA_EMPLOYEE,
    MASTERDATA_FIXED_ASSET,
    MASTERDATA_GENERAL_LEDGER,
    MASTERDATA_MANUAL_ARTICLE,
    MASTERDATA_PAYMENT_METHOD,
    MASTERDATA_REPRESENTATIVE,
    MASTERDATA_SALES_ORGANISATION,
    MASTERDATA_SITE_ENGINEER,
    MASTERDATA_STORAGE_SITE,
    MASTERDATA_TASK_TYPE,
    MASTERDATA_TAX_RATE,
    MASTERDATA_CHECKLIST,
    MASTERDATA_CONDITION,
    MASTERDATA_DEPARTMENT,
    MASTERDATA_DISTRIBUTION_TYPE,
    MASTERDATA_DOCUMENT_NOTE_CATEGORY,
    MASTERDATA_MEMBER,
    MASTERDATA_POSTING_SYMBOL,
    MASTERDATA_PRODUCT_DEVELOPMENT,
    MASTERDATA_PRODUCT_GROUP,
    MASTERDATA_PRODUCTION_SITE,
    MASTERDATA_PROJECT,
    MASTERDATA_PROMOTION,
    MASTERDATA_PURCHASE_ORGANIZATION,
    MASTERDATA_SELLING_TYPE,
    MASTERDATA_STOCK,
    MASTERDATA_STOCK_SYMBOL,
    MASTERDATA_SUPPLIER,
    MASTERDATA_TERMS_OF_PAYMENT,
    MASTERDATA_TIME_MOVEMENT_TYPE,
    MASTERDATA_UNIT,
    MASTERDATA_USER,
    MASTERDATA_CONTACT,
  ];
}
